var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.asyncShow)?_c('webview',{ref:"webview",staticClass:"flex1",style:(_vm.style),attrs:{"allowpopups":"","useragent":_vm.userAgent,"src":_vm.src,"nodeintegration":"","disablewebsecurity":"","nodeintegrationinsubframes":"","webPreferences":_vm.webPreferences,"partition":_vm.webviewKey,"preload":_vm.preloadFile}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }